import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

// A password <input> with a show/hide eye toggle, so someone can check
// they typed it correctly before submitting — plain `type="password"`
// masking gives no way to catch a typo (wrong case, a fat-fingered
// character, autocorrect/autofill mangling it) until the submit already
// fails. Drop-in replacement for a bare <input type="password">: forwards
// every prop straight through except `className`, which is merged with the
// extra right-padding the toggle button needs to sit inside the field
// without overlapping typed text.
//
// Deliberately its own small component rather than 4 separate inline
// copies across LoginPage.js/RegisterPage.js/UserManagement.js — this is
// the first shared form-input component in the app (see components/ having
// none previously), which is worth it here specifically because the exact
// same eye-icon-button markup would otherwise be copy-pasted verbatim 4
// times with no natural single owner to keep them in sync.
export default function PasswordInput({ className = '', ...props }) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative">
      <input
        {...props}
        type={visible ? 'text' : 'password'}
        className={`${className} pr-10`}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        tabIndex={-1}
        aria-label={visible ? 'Hide password' : 'Show password'}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-gray-600 hover:text-gray-600"
      >
        {visible ? <EyeOff className="w-4 h-4" aria-hidden="true" /> : <Eye className="w-4 h-4" aria-hidden="true" />}
      </button>
    </div>
  );
}
